import { render } from "./EsimPackageCard.vue?vue&type=template&id=cb528b76&scoped=true"
import script from "./EsimPackageCard.vue?vue&type=script&lang=js"
export * from "./EsimPackageCard.vue?vue&type=script&lang=js"

import "./EsimPackageCard.vue?vue&type=style&index=0&id=cb528b76&scoped=true&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb528b76"]])

export default __exports__